// Named import: the SDK is a Babel-CJS package whose *default* import breaks
// under Vite 8 / Rolldown's unified CJS default-interop (resolves to the module
// namespace object, not the function). The named export is interop-stable.
import { Intercom } from "@intercom/messenger-js-sdk";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { type FC, useEffect } from "react";
import { useLocation } from "react-router";

import { INTERCOM_ID } from "~/constants/common";
import { useScreenResolution } from "~/hooks/useScreenResolution";

const LAUNCHER_WIDTH = 48;
const LAUNCHER_RIGHT_OFFSET = 20;
const LAUNCHER_GUTTER = LAUNCHER_WIDTH + LAUNCHER_RIGHT_OFFSET;

export const IntercomInit: FC = () => {
  const theme = useTheme();
  const { isMobile } = useScreenResolution();
  const location = useLocation();

  const isEventPage = location.pathname.includes("/event/");
  const hasLauncherGutter = useMediaQuery(
    `(min-width:${theme.breakpoints.values.xl + LAUNCHER_GUTTER * 2}px)`,
  );

  const hideLauncher = isMobile || (isEventPage && !hasLauncherGutter);

  useEffect(() => {
    if (INTERCOM_ID) {
      Intercom({
        app_id: INTERCOM_ID,
        action_color: "#F2F2F2",
        theme_mode: theme.palette.mode === "dark" ? "dark" : "light",
        vertical_padding: 65,
        hide_default_launcher: hideLauncher,
      });
    }
  }, [hideLauncher, theme]);

  return null;
};
